import React from "react";
import "./About.css";
import Banner from "./Banner";
import Brands from "./Brands";
const About = () => {
  return (
    <div>
      <Banner title="about" imgURL="/images/mainbg.jpg" />
      <div className="About_Container">
        <div className="about_text">
          <h4>
            DAGA GROUP is running by Mr. Rajkumar Daga and Mr. Ashok Daga . We
            started operations in 1973, when our first firm was registered by
            name 'Anupam Steel Centre'. We are distributors for JSW Steel Ltd &
            Rathi Group and channel partner of SBF Ispat Pvt Ltd. We deal in all
            items of iron and steel such as: TMT BARS, ANGLES, CHANNELS, BEAMS,
            MS PLATES, HR & CR PLATES , GC SHEET, GISHEET , CHEQUERED PLATE and
            STAINLESS STEEL WIRE RODS. We have our stockyard in Palwal, from
            where we are able to service many locations. Our expertise is in
            providing solutions for any construction related steel demand. We
            can cater all over the country.
          </h4>
        </div>
        <div className="aboutsection_image">
          <img
            className="aboutsection_image1"
            src="/images/aboutimage.jpg"
            alt="About Section"
          />
        </div>
      </div>
      <Banner title="about" imgURL="/images/clientsbanner.jpg" />
      <h1 className="Abouttexttext">
        Construction Companies on Large Scale Projects
      </h1>
      <Brands />
    </div>
  );
};

export default About;
